module.exports = __webpack_public_path__ + "img/business3.448bed55.jpg";